import React from "react"
import PropTypes from 'prop-types';
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps';

export default class Shortcut extends React.Component {
  constructor(props) {
    super(props)

    this.config = { 
      types : [
        {
          title: 'default',
          isDefault: true,
        }
      ],
      modifiers: [
        "inverse"
      ],
      states : []
    }

  }

  render() {
    const { icon, children, target, disabled, href, ...rest } = this.props
    const props = clearProps(this.props)
    
    return  <a {...props} className={resolveProps(this.props, this.config, 'Shortcut')} href={href} target={target} disabled={disabled}>
      <span className={"mdn-Shortcut-icon mdn-Icon-"+icon+" mdn-Icon--md"}></span>
      <p className="mdn-Shortcut-text">{children}</p>
    </a>
  }
}

Shortcut.propTypes = {
  icon : PropTypes.string,
  children : PropTypes.node,
  config: PropTypes.object,
  disabled : PropTypes.bool,
  href: PropTypes.string

}